import React from 'react';

import { Trans } from 'react-i18next';

import config from '@app/config';

import { type AuthStep } from './types';

import { AuthFooterContainer, ExternalLink } from './styles';

interface AuthFooterProps {
    currentStep: AuthStep;
}

const { privacyLink, supportLink, termsLink } = config;

export function AuthFooter({ currentStep }: AuthFooterProps) {
    const isSignupStep = ['entry', 'sign-up-with-email'].includes(currentStep);

    return isSignupStep ? (
        <AuthFooterContainer>
            <Trans ns="auth" i18nKey="footer_legal">
                <ExternalLink href={termsLink}>0</ExternalLink>
                <ExternalLink href={privacyLink}>1</ExternalLink>
            </Trans>
        </AuthFooterContainer>
    ) : (
        <AuthFooterContainer>
            <ExternalLink href={termsLink}>Terms of Service</ExternalLink> &middot;{' '}
            <ExternalLink href={privacyLink}>Privacy Policy</ExternalLink> &middot;{' '}
            <ExternalLink href={supportLink}>Help</ExternalLink>
        </AuthFooterContainer>
    );
}
